/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type LandingPageInfo = {
    ID: string;
    TITLE: string;
    EXPST: string;
    EXPEND: string;
    CTYPE: LandingPageInfo.CTYPE;
    CURL: Array<string>;
    HCPY: string;
    SCPY: string;
    NTTXT: string;
};

export namespace LandingPageInfo {

    export enum CTYPE {
        ALL = 'ALL',
        PARTIAL = 'PARTIAL',
    }


}

